<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <p-toast key="toastmsg"></p-toast>
                <div class="card">
                    <div class="p-fluid p-formgrid p-grid m-0">
                        <div class="p-field p-col-12 div-border p-p-0">
                            <h3 class="head-page-title">
                                Bank List - <span>{{userName | titlecase}} </span>
                           <span>({{mobileNumber}})</span>
                            </h3>
                        </div>
                    </div>
                    <main id="msform">
                        <div class=" col-md-12 bottom-container tablesections p-p-0">
                            <div class="header-container box w-100">
                                <div class="step " id="step2">

                                    <div class="col-md-12 p-p-0">
                                        <div class="bank-list pb-0">
                                            <ul>
                                                <li *ngFor="let bank of bankDetails">
                                                    <!-- <input class="form-check-input" type="radio" name="bank-list"
                                                id="bank-list1"> -->
                                                    <label class="form-check-label" for="bank-list1">
                                                        <div class="media">
                                                            <div class="media-left">
                                                                <img src="../../../../../assets/images/backend-image/header/bankIcon.svg" alt="">
                                                            </div>
                                                            <div class="media-body">
                                                                <div class="bank-name">
                                                                    {{bank.bankName}} <span *ngIf="bank.isPrimary"
                                                                        class="primery-account-selected">(Primary)</span>
                                                                </div>
                                                                <div class="bank-number">
                                                                    {{bank.bankAccountNumber}}
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </label>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
                <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
            </div>
        </div>
    </div>
</div>